import { takeEvery } from 'redux-saga/effects'
import { cartActions } from './actions'

/**
 * Saga para emitir evento quando item é adicionado
 */
function* addItemSaga(action: ReturnType<typeof cartActions.addItem>): Generator {
  const { product, quantity, showToast } = action.payload
  
  // Emitir evento customizado para o toast
  if (showToast !== false) {
    const event = new CustomEvent('itemAddedToCart', {
      detail: { product, quantity }
    })
    window.dispatchEvent(event)
  }
  yield null // Para evitar erro de gerador sem yield
}

/**
 * Root saga do módulo Cart
 */
export function* cartSaga(): Generator {
  yield takeEvery(cartActions.addItem.type, addItemSaga)
}

